import { APP_USER_GROUPING_PROJECT_PROFILE_HISTORY_LIST_ROUTE } from 'config/route-consts';
import React from 'react'
import { Redirect, Route, Switch } from "react-router-dom";
import AppUserGroupingProjectProfileHistoryList from './AppUserGroupingProjectProfileHistoryList/AppUserGroupingProjectProfileHistoryList';

function AppUserGroupingProjectProfileHistoryView() {
    return (
        <Switch>
            <Route
                key={APP_USER_GROUPING_PROJECT_PROFILE_HISTORY_LIST_ROUTE}
                path={APP_USER_GROUPING_PROJECT_PROFILE_HISTORY_LIST_ROUTE}
                render={(props: any) => {
                    return <AppUserGroupingProjectProfileHistoryList {...props} />;
                }}
            />
            <Redirect to={APP_USER_GROUPING_PROJECT_PROFILE_HISTORY_LIST_ROUTE} />
        </Switch>
    );
}

export default AppUserGroupingProjectProfileHistoryView
